import React, { Suspense, lazy } from 'react';
import { RouteConfig } from './types/routeConfig';
import Sidebar from '../components/antd/sidebar/sidebar';
import { Outlet } from 'react-router-dom';
import Login from '../pages/login/login';
import Signup from '../pages/login/Signup';
import Loader from '../components/common/Loader';
import BillingLogin from '../pages/login/billing_login';
import ProtectedRoute from '../components/common/ProtectedRoute';

import LandingHeader from '../components/Header/LandingHeader';
const UnitCrud = lazy(() => import('../pages/Unit/crud'));
const Dashboard = lazy(() => import('../pages/Dashboard'));
const DailyAttendance = lazy(
  () => import('../pages/Attendance/DailyAttendance')
);

const DynamicPageManager = lazy(() => import('../components/cms/DynamicPageManager'));
const DynamicPageRoute = lazy(() => import('../components/cms/DynamicPageRoute'));
const PageDataManager = lazy(() => import('../components/cms/PageDataManager'));
const CmsDashboard = lazy(() => import('../components/cms/CmsDashboard'));
const CmsPageCreator = lazy(() => import('../components/cms/CmsPageCreator'));


const routerData: RouteConfig[] = [
  // Single Dynamic Route for All Content Pages
  {
    key: 'dynamic_content',
    path: '/*',
    element: (
      <Suspense fallback={<Loader />}>
        <LandingHeader />
        <DynamicPageRoute />
      </Suspense>
    ),
    children: [],
  },

  // Authentication Routes
  {
    key: 'login',
    path: '/login',
    element: (
      <Suspense fallback={<Loader />}>
        <Login />
      </Suspense>
    ),
    children: [],
  },
  {
    key: 'school_login',
    path: '/school_login',
    element: (
      <Suspense fallback={<Loader />}>
        <BillingLogin />
      </Suspense>
    ),
    children: [],
  },
  {
    key: 'admin',
    path: '/admin',
    element: (
      <Suspense fallback={<Loader />}>
        <Login />
      </Suspense>
    ),
    children: [],
  },
  {
    key: 'signup',
    path: '/signup',
    element: (
      <Suspense fallback={<Loader />}>
        <Signup />
      </Suspense>
    ),
    children: [],
  },

  // School CMS Routes
  {
    key: 'school_cms',
    path: '/cms',
    element: (
      <Suspense fallback={<Loader />}>
        <Sidebar>
          <Outlet />
        </Sidebar>
      </Suspense>
    ),
    children: [
      {
        key: 'dashboard',
        path: 'dashboard',
        element: (
          <Suspense fallback={<Loader />}>
            <Dashboard />
          </Suspense>
        ),
        children: [],
      },

      {
        key: 'unit_crud',
        path: 'unit_crud',
        element: (
          <Suspense fallback={<Loader />}>
            <UnitCrud />
          </Suspense>
        ),
        children: [],
      },

      {
        key: 'daily_attendance',
        path: 'daily_attendance',
        element: (
          <Suspense fallback={<Loader />}>
            <DailyAttendance />
          </Suspense>
        ),
        children: [],
      },

      // Dynamic Page Management within CMS (Admin Only)
      {
        key: 'cms_pages',
        path: 'pages',
        element: (
          <Suspense fallback={<Loader />}>
            <ProtectedRoute requiredRole="admin">
              <CmsPageCreator />
            </ProtectedRoute>
          </Suspense>
        ),
        children: [],
      },

      // CMS Dashboard - Comprehensive CMS Management
      {
        key: 'cms_dashboard',
        path: 'cms-dashboard',
        element: (
          <Suspense fallback={<Loader />}>
            <ProtectedRoute requiredRole="admin">
              <CmsDashboard />
            </ProtectedRoute>
          </Suspense>
        ),
        children: [],
      },

      // Page Data Manager - for switching between local and API data
      {
        key: 'page_data_manager',
        path: 'page-data',
        element: (
          <Suspense fallback={<Loader />}>
            <ProtectedRoute requiredRole="admin">
              <PageDataManager />
            </ProtectedRoute>
          </Suspense>
        ),
        children: [],
      },
    ],
  },
];

export default routerData;
